import React from "react";
import { Brain } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import useRetryFetch from "../../hooks/useRetryFetch";
import { liftEntity } from "../../api/mentalModels";

/**
 * Drop-in dropdown item for takeaway cards: lifts the entity into a mental
 * object (idempotent server-side) and switches to the Mental Models tab with
 * the object pre-opened. Self-contained — no prop threading through hosts.
 */
const MmLiftMenuItem: React.FC<{
  entityId: string;
  entityType?: "user_takeaway" | "user_trait";
}> = ({ entityId, entityType = "user_takeaway" }) => {
  const retryFetch = useRetryFetch();
  const { t } = useTranslation();

  const handleLift = async () => {
    try {
      const res = await liftEntity(retryFetch, { entityType, entityId });
      sessionStorage.setItem("mm_open_object", res.object._id);
      localStorage.setItem("workspace_active_tab", "mental_models");
      window.dispatchEvent(new CustomEvent("workspace-set-tab", { detail: "mental_models" }));
    } catch (e) {
      console.error("lift failed:", e);
    }
  };

  return (
    <DropdownMenuItem onClick={handleLift}>
      <Brain className="h-4 w-4 mr-2" />
      {t("mm_lift_action", "Work on this in Mental Models")}
    </DropdownMenuItem>
  );
};

export default MmLiftMenuItem;
